import React, { FunctionComponent, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import { ICustomerLookupRecord } from '../lookups/CustomerLookup';

interface IProps {
  apply: Function;
  CODCrossReferences: ICustomerLookupRecord[];
  container: Object;
  hide: Function;
  show: boolean;
}

const CODCrossReferenceSelectionModal: FunctionComponent<IProps> = ({
  apply,
  CODCrossReferences,
  container,
  hide,
  show,
}) => {
  const [activeSelection, setActiveSelection] = useState<number | null>(null);

  return (
    <Modal
      backdrop="static"
      container={container as any}
      dialogClassName="sk-CODCrossReferenceSelectionModal"
      onHide={hide as any}
      show={show}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>Customers On File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        The following customers were located on file with the same phone number. If you wish to load one of these
        accounts, select it and press Apply.
        <div className="sk-selectionTypeContainer">
          {CODCrossReferences.map((details, index) => {
            return (
              <div
                className={classNames({
                  'sk-selected': activeSelection === index,
                  'sk-selection-item': true,
                })}
                onClick={() => setActiveSelection(index)}
                key={`customerRef${index}`}
              >
                <span style={{ textDecoration: 'underline' }}>Cust# {details.itemid}</span>
                <br />
                {details.Name}
                <br />
                {details.Address}
                <br />
                {details.City}, {details.State} {details.Zip}
                <br />
                {details.Phone}
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={() => hide()}>
          Cancel
        </Button>
        <Button variant="success" disabled={activeSelection === null} onClick={() => apply(activeSelection)}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CODCrossReferenceSelectionModal;
